<template>
  <div id="app">
    <router-view />
    <Login :visible="show" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Login from "@/components/login/index";
import Cookies from "js-cookie";
export default {
  name: "App",
  components: {
    Login,
  },

  data() {
    return {
      show: false,
    };
  },

  watch: {
    // 统一登录设置cookie
    /* $route(next, prev) {
      const uri = next.query.platform_access_token
        ? next.fullPath.split("platform_access_token")[0]
        : next.fullPath;
      const fullPath = process.env.VUE_APP_LOCATION + uri;
      Cookies.set("fullPath", fullPath, { domain: process.env.VUE_APP_DOMAIN });
    }, */
  },
};
</script>
<style>
.el-loading-mask {
  z-index: 1999;
}

.el-radio__input.is-checked .el-radio__inner {
  color: #bc9783 !important;
  border-color: #bc9783;
  background: #bc9783;
}

.el-select-dropdown__item.selected, .el-date-table td.today span {
  color: #bc9783 !important;
}

.el-radio__inner:hover {
  border-color: #bc9783;
}

.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close, .el-date-table td.available:hover {
  color: #bc9783;
}


.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background-color: transparent;
  color: #bc9783;
}

.el-input-number__decrease:hover,
.el-input-number__increase:hover {
  color: #bc9783;
}

.el-date-table td.today.start-date span, .el-date-table td.today.end-date span {
  color: white !important;
}

.el-date-table td.start-date span, .el-date-table td.end-date span {
  background-color: #bc9783 !important;
}
</style>
